import React from 'react';

// Fades and lifts its content in as it scrolls into view. Driven entirely by
// CSS scroll-driven animation (see .reveal in App.css), so content is always
// visible by default: in browsers without support, for visitors who prefer
// reduced motion, and in background tabs, print, and link-preview tools.
const Reveal = ({ children, className = '' }) => (
  <div className={`reveal ${className}`}>{children}</div>
);

export default Reveal;
